export default "__VITE_ASSET__38i5uAru__"